import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ParamsDataFinancialPending } from 'utils/typeServices';
import { HandleParseLinkNf } from 'utils/parseLinkNf';

import {
    Box,
    Table,
    TableRow,
    TableCell,
    TableBody,
    TableHead,
    Typography,
    TableContainer,
} from '@mui/material';

import { ModalPaymentMethodTicket, ModalPaymentMethodTicketConfirm } from 'components/views/Invoices/Modals';

import { ButtonCustom } from './styles';

const dataLegend = [
    'Status',
    'Vencimento',
    'Valor',
    'Forma de pagamento',
    'Placa',
    'Serviços',
    'Periodo',
    'Tipo de Cobrança',
];

type Params = {
    invDetailsList: Array<Array<String>>;
    typeInvoice: 'nextInv' | 'overdueInv' | 'paidInv';
    invDetailsListObj: Array<ParamsDataFinancialPending>;
}

const TableDesk = ({ invDetailsList, typeInvoice, invDetailsListObj }: Params) => {
    const navigate = useNavigate();

    const [indexPosition, setIndexPosition] = useState(0);
    const [showModalPaymentMethodTicket, setShowModalPaymentMethodTicket] = useState(false);
    const [showModalPaymentMethodTicketConfirm, setShowModalPaymentMethodTicketConfirm] = useState(false);

    const handlePayInvoice = (index: number) => {
        setIndexPosition(index);
        if (invDetailsListObj[index].ID_FORMA_PGTO !== 22) {
            navigate('pagamento', {
                state: {
                    CHAVE_PAGAMENTO: invDetailsListObj[index].CHAVE_PAGAMENTO,
                    CD_FORMA_PAGAMENTO: invDetailsListObj[index].CD_FORMA_PAGAMENTO,
                }
            });
        } else {
            setShowModalPaymentMethodTicket(true);
        }
    }

    return (
        <>
            <TableContainer sx={{
                overflowX: 'inherit',
                display: {
                    xs: 'none',
                    md: 'block'
                }
            }}>
                <Table aria-label="simple table" sx={{ position: 'relative' }}>
                    <TableHead>
                        <TableRow>
                            {dataLegend.map((titleLegend, index) =>
                                <TableCell key={index} sx={{
                                    border: 'none',
                                    padding: '0 0 .35rem',
                                }}>
                                    <Typography
                                        fontSize='.75rem'
                                        color={index === 0 ? 'primary.main' : 'grey.400'}
                                        fontWeight={600}
                                        lineHeight='1rem'
                                        sx={{
                                            padding: '.25rem 0 0 .25rem',
                                            borderBottom: '1px solid rgba(141, 155, 181, 0.35)',
                                        }}>
                                        {titleLegend}
                                    </Typography>
                                </TableCell>
                            )}
                            <TableCell sx={{
                                border: 'none',
                                padding: '0 0 .35rem',
                                verticalAlign: 'bottom',
                            }}>
                                <Box sx={{
                                    padding: '.25rem 0 0 .25rem',
                                    borderBottom: '1px solid rgba(141, 155, 181, 0.35)',
                                }} />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    {invDetailsList?.length === 0 &&
                        <Typography
                            fontSize='1rem'
                            fontWeight={700}
                            paddingTop='1.75rem'
                            color={typeInvoice === 'nextInv' ? '#0AA8E3' : typeInvoice === 'overdueInv' ? '#FF0000' : '#97C93D'}
                        >
                            Sem faturas disponíveis
                        </Typography>
                    }
                    {invDetailsList?.map((listNames, indexBody) =>
                        <TableBody key={indexBody}>
                            <Box sx={{
                                width: '100%',
                                display: 'flex',
                                height: '.5rem',
                            }} />
                            <TableRow>
                                <TableCell sx={{
                                    border: 'none',
                                    height: typeInvoice === 'overdueInv' ? '' : 'auto',
                                    padding: '.45rem 0',
                                    verticalAlign: 'top',
                                    borderRadius: '4px 0 0 4px',
                                    backgroundColor: typeInvoice === 'overdueInv' ? 'rgba(255, 0, 0, 0.1)' : 'transparent',
                                }}>
                                    <Typography
                                        fontWeight={700}
                                        fontSize='.75rem'
                                        color={typeInvoice === 'overdueInv' ? '#FF0000' : typeInvoice === 'nextInv' ? '#0AA8E3' : '#97C93D'}
                                        lineHeight='1rem'
                                        sx={{
                                            minWidth: '4.5rem',
                                            padding: '.25rem 0 0 .3rem',
                                        }}
                                    >
                                        {typeInvoice === 'overdueInv' ? 'VENCIDA' : typeInvoice === 'nextInv' ? 'A VENCER' : 'PAGO'}
                                    </Typography>
                                </TableCell>

                                {listNames?.map((names, index) =>
                                    index !== 2 && (
                                        <TableCell sx={{
                                            border: 'none',
                                            height: typeInvoice === 'overdueInv' ? '4.375rem' : 'auto',
                                            padding: '.45rem 0',
                                            borderRadius: '0px',
                                            verticalAlign: 'top',
                                            backgroundColor: typeInvoice === 'overdueInv' ? 'rgba(255, 0, 0, 0.1)' : 'transparent',
                                        }}
                                            key={index}
                                        >
                                            <Typography
                                                fontWeight={index === 1 ? 700 : 400}
                                                fontSize={index === 1 ? '.875rem' : '.75rem'}
                                                color='primary.main'
                                                lineHeight='1rem'
                                                textTransform='capitalize'
                                                sx={{
                                                    maxWidth: index === 1 ? '7.5rem' : index == 3 ? '7.2rem' : '5.93rem',
                                                    whiteSpace: index == 1 ? 'nowrap' : 'normal', 
                                                    padding: '.25rem 0 0 .3rem',
                                                }}
                                            >
                                                {index === 4 ?
                                                    names
                                                    :
                                                    index === 1 ?
                                                        <Box sx={{ minHeight: '1rem' }}>
                                                            {names !== 'undefined' ? names : ''}
                                                        </Box>
                                                        :
                                                        names?.toLowerCase()}
                                            </Typography>

                                            {((typeInvoice === 'overdueInv') && (index === 1)) &&
                                                <Typography fontSize='.5625rem' lineHeight='.7rem' sx={{
                                                    padding: '.2rem 0 0 .3rem',
                                                }}>
                                                    Valor original<br />
                                                    {listNames[2]}
                                                </Typography>
                                            }
                                        </TableCell>
                                    ))}


                                <TableCell sx={{
                                    border: 'none',
                                    height: typeInvoice === 'overdueInv' ? '4.375rem' : 'auto',
                                    padding: '.45rem 0',
                                    maxWidth: '8.21rem',
                                    verticalAlign: 'top',
                                    borderRadius: '0 4px 4px 0',
                                    backgroundColor: typeInvoice === 'overdueInv' ? 'rgba(255, 0, 0, 0.1)' : 'transparent',
                                }}>
                                    {((typeInvoice === 'paidInv') || (invDetailsListObj[indexBody]?.NR_STATUS === 3)) ?
                                        <Box sx={{
                                            minWidth: '5rem'
                                        }} />
                                        :
                                        <Box sx={{
                                            display: 'flex',
                                            maxWidth: '8.21rem',
                                            paddingRight: '.67rem',
                                            justifyContent: 'space-between',
                                        }}>
                                            <ButtonCustom
                                                variant='contained'
                                                color='secondary'
                                                sx={{
                                                    width: '3.4375rem',
                                                    height: '3.4375rem'
                                                }}
                                                disabled={(invDetailsListObj[indexBody]?.CHAVE_PAGAMENTO && (invDetailsListObj[indexBody]?.CD_FORMA_PAGAMENTO !== undefined)) ? false : true}
                                                onClick={() => handlePayInvoice(indexBody)}
                                            >
                                                PAGAR AGORA
                                            </ButtonCustom>
                                            <ButtonCustom sx={{
                                                border: '1px solid #0C1C33',
                                                width: '3.4375rem',
                                                height: '3.4375rem'
                                            }}
                                                onClick={() => window.open(HandleParseLinkNf({ NFENumber: invDetailsListObj[indexBody].NUM_NFE, InscMunicipalNumber: invDetailsListObj[indexBody].NR_INSC_MUN, NFEVerificationNumber: invDetailsListObj[indexBody].COD_VERIF_NFE }), '_blank')}
                                            >
                                                NOTA FISCAL
                                            </ButtonCustom>
                                        </Box>
                                    }

                                </TableCell>
                            </TableRow>
                            <Box sx={{
                                width: '100%',
                                display: 'flex',
                                padding: '.5rem',
                                position: 'absolute',
                            }}>
                                {indexBody !== (invDetailsList.length - 1) &&
                                    <Box sx={{
                                        width: '100%',
                                        height: '1px',
                                        backgroundColor: 'rgba(141, 155, 181, 0.35)',
                                    }} />}
                            </Box>
                            <Box sx={{
                                width: '100%',
                                display: 'flex',
                                height: '.5rem',
                            }} />
                        </TableBody>
                    )}
                </Table>
            </TableContainer>
            <ModalPaymentMethodTicket open={showModalPaymentMethodTicket} handleClick={(e) => {
                if (e) {
                    setShowModalPaymentMethodTicketConfirm(e);
                }
                setShowModalPaymentMethodTicket(false);
            }} />
            <ModalPaymentMethodTicketConfirm open={showModalPaymentMethodTicketConfirm} handleClick={(e) => {
                if (e) {
                    navigate('pagamento', {
                        state: {
                            CHAVE_PAGAMENTO: invDetailsListObj[indexPosition].CHAVE_PAGAMENTO,
                            CD_FORMA_PAGAMENTO: invDetailsListObj[indexPosition].CD_FORMA_PAGAMENTO,
                        }
                    });
                }
                setShowModalPaymentMethodTicketConfirm(false);
            }} />
        </>
    );
}

export default TableDesk;